var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransbankFailed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 230,
    height: 230,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rect\\xE1ngulo 5470",
    transform: "translate(0 .342)",
    fill: "none",
    d: "M0 0h230v230H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 19650"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17923",
    clipPath: "url(#a)",
    transform: "translate(0 -.342)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17918"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17917",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 6728",
    d: "M230.342 115.171a115.171 115.171 0 1 0-115.171 115.171 115.17 115.17 0 0 0 115.171-115.171",
    fill: "#e02d35"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17922"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17921",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 6733",
    d: "m60.327 172.848 57.463 57.46a115.17 115.17 0 0 0 112.268-107.1L170.015 63.16Z",
    fill: "#b4181f"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 6731",
    d: "M60.328 63.159a16.461 16.461 0 0 1 23.21 0l86.476 86.476a16.412 16.412 0 1 1-23.21 23.21L60.328 86.367a16.463 16.463 0 0 1 0-23.212",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 6730",
    d: "M60.328 172.846a16.461 16.461 0 0 1 0-23.21l86.476-86.474a16.412 16.412 0 0 1 23.211 23.205l-86.476 86.479a16.458 16.458 0 0 1-23.21 0",
    fill: "#fff"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransbankFailed);
export default __webpack_public_path__ + "static/media/transbank_failed.38b1a4ee630a6c53932aae8730f71a49.svg";
export { ForwardRef as ReactComponent };